import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@wix/design-system';
import { ThemedText } from '../../ThemedComponents';
import { DeviceRadioList } from './DeviceRadioList';
import { EnableErrorSectionHelper } from './EnableErrorSectionHelper';

/**
 * Body of the redesigned "Select device" step — the "choose the device" message +
 * the shared `DeviceRadioList`. Card chrome is provided by `WixAppWizardRedesign`.
 */
export const SelectDeviceBody: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Box direction="vertical" width="100%" gap={2}>
      <EnableErrorSectionHelper />
      <ThemedText>
        {t('wixAppEnforcement.addOwnerApp.wizard.select.message')}
      </ThemedText>
      <DeviceRadioList />
    </Box>
  );
};
